"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookIcon = FacebookIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function FacebookIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 20 21"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.96129 18.8551V11.0347H5.83398V8.21891H7.96129V5.81389C7.96129 3.92401 9.2179 2.18848 12.1134 2.18848C13.2857 2.18848 14.1526 2.29773 14.1526 2.29773L14.0843 4.92716C14.0843 4.92716 13.2002 4.91879 12.2355 4.91879C11.1913 4.91879 11.024 5.38654 11.024 6.16289V8.21891H14.1673L14.0305 11.0347H11.024V18.8551H7.96129Z",
    fill: props.color || '#1A77F2',
    id: "Vector"
  }));
}